import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const GoogleTagManager = ({ id }: { id: string }) => {
  useEffect(() => {
    TagManager.initialize({ gtmId: id });
  }, [id]);

  return <React.Fragment />;
};
